import {
  SelectedCalloutMeta,
  useRulesDetailModalContext,
} from 'contexts/RulesDetailModalContext';
import { useCallback } from 'react';

import { Box, Text, Tag, Button, GDTSymbolText } from '@frontend/components';

type SelectedCalloutProps = {
  selectedCalloutMeta: SelectedCalloutMeta;
  onDeleteGroup: () => void;
};

export const SelectedCallout = ({
  selectedCalloutMeta,
  onDeleteGroup,
}: SelectedCalloutProps) => {
  const { clearCallout } = useRulesDetailModalContext();

  const handleDeleteSignal = useCallback(() => {
    onDeleteGroup();
    clearCallout();
  }, [clearCallout, onDeleteGroup]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={1}
      bg="interaction.active"
      pl={1.5}
      pr={1}
      py={0.75}
      borderRadius="md"
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Text size="md" fontWeight="medium" color="feature.onInteraction">
          Selected item
        </Text>
        <Tag
          fontSize="sm"
          fontWeight="500"
          colorScheme="gray"
          bg="white"
          borderRadius="full"
          maxWidth="200px"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          px={1.5}
          py={0.5}
        >
          <GDTSymbolText size="sm">
            {selectedCalloutMeta.description ?? ''}
          </GDTSymbolText>
        </Tag>
      </Box>
      <Button size="sm" variant="secondary" onClick={handleDeleteSignal}>
        Clear
      </Button>
    </Box>
  );
};
